import React, { Component } from 'react';
import { inject, observer } from "mobx-react";
import { Row, Col } from "antd";

@inject('store')
@observer
class rooms extends Component {
    render() {
        return (
            <div className="rooms">
                <Row>
                    <Col span={12}>
                        <div className="total_style">竞争对手客房数据</div>
                        <div id="staff_left" style={{ height: 400, width: '100%' }} />
                    </Col>
                    <Col span={12}>
                        <div className="total_style">员工产量</div>
                        <div id="staff_right" style={{ height: 400, width: '100%' }} />
                    </Col>
                </Row>
            </div>
        );
    }
}

export default rooms;


// WEBPACK FOOTER //
// ./src/components/BI/General/Staff.js